module.exports = __webpack_public_path__ + "img/距离.d05d6ed4.svg";